// extracted by mini-css-extract-plugin
module.exports = {"roundLoader":"roundLoader_roundLoader__3zJsp","loading":"roundLoader_loading__1CX5P"};